import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import JesHistoryTable from 'parog-web/components/jes-history-table';
import capitalize from 'parog-web/helpers/capitalize';
import contextualRoute from 'parog-web/helpers/contextual-route';
import type Patient from 'parog-web/models/patient';
import alertingJeStyle from 'parog-web/modifiers/alerting-je-style';
import type NavigationService from 'parog-web/services/navigation';
import PageContainer from 'ui-kit/components/page-container';

interface Args {
  patient: Patient;
}

export default class CompoundSurveyHistoryTableComponent extends Component<Args> {
  @service declare navigation: NavigationService;

  <template>
    <PageContainer @title='Historique des questionnaires  '>
      <:content>
        <JesHistoryTable @patient={{@patient}}>
          <:columns as |Column|>
            <Column
              @modelName='compound-survey-completed-journal-event'
              @isTimePopupDisabled={{true}}
            >
              <:label>Questionnaires</:label>
              <:value as |je|>
                <span class='show-shyone-on-hover'>
                  <span
                    {{alertingJeStyle je}}
                    class={{if je.isAlertingJournalEvent 'text-red'}}
                  >
                    {{capitalize je.survey.title}}
                  </span>
                  <LinkTo
                    @route={{contextualRoute
                      'compound-surveys.edit.survey-completed'
                    }}
                    @model={{je.id}}
                    class='shyone'
                    data-test-edit
                  >
                    <i class='pencil alternate primary icon'></i>
                  </LinkTo>
                </span>
              </:value>
            </Column>
          </:columns>
        </JesHistoryTable>
      </:content>
    </PageContainer>
  </template>
}
